import { useTranslation } from 'react-i18next'
import { AuroraAssetGroup } from '../types'
import { useState } from 'react'
import { setAuroraHeatPumpStatus } from '../services/aurora'
import { AuroraHeatPumpStatus } from '../enums'
import { useDispatch } from 'react-redux'
import AuroraHeatPumpStatusControl from './AuroraHeatPumpStatusControl'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'
import { useAuroraStack } from '../hooks'

export interface AuroraAssetGroupHeatPumpStatusControlProps {
  auroraAssetGroup: AuroraAssetGroup
  beforeSubmit?: (status: AuroraHeatPumpStatus) => void
  afterSubmit?: (status: AuroraHeatPumpStatus) => void
  onError?: (error: unknown) => void
}

export default function AuroraAssetGroupHeatPumpStatusControl({
  auroraAssetGroup,
  beforeSubmit,
  afterSubmit,
  onError
}: AuroraAssetGroupHeatPumpStatusControlProps) {
  const { t } = useTranslation('aurora')

  const dispatch = useDispatch()

  const {
    auroras,
    heatPumpStatus: initialHeatPumpStatus,
    handleAuroraAwhpActionError
  } = useAuroraStack(auroraAssetGroup)

  const [status, setStatus] = useState<AuroraHeatPumpStatus>(initialHeatPumpStatus)

  const [isSubmitting, setSubmitting] = useState<boolean>(false)

  async function handleSubmit(status: AuroraHeatPumpStatus) {
    try {
      setSubmitting(true)

      beforeSubmit?.(status)

      await Promise.all(auroras.map((aurora) => setAuroraHeatPumpStatus(aurora.id, status)))
      setStatus(status)
      dispatch(createSuccessNotification(t('setHeatPumpStatusSuccess')))

      afterSubmit?.(status)
    } catch (error) {
      onError?.(error)
      handleAuroraAwhpActionError(error, t('setHeatPumpStatusError'))
    } finally {
      setSubmitting(false)
    }
  }

  if (auroras.length === 0) {
    return null
  }

  return (
    <AuroraHeatPumpStatusControl value={status} loading={isSubmitting} onSubmit={handleSubmit} />
  )
}
